import { render } from "./CopyToClipboard.vue?vue&type=template&id=2241a4aa&scoped=true"
import script from "./CopyToClipboard.vue?vue&type=script&lang=js"
export * from "./CopyToClipboard.vue?vue&type=script&lang=js"

import "./CopyToClipboard.vue?vue&type=style&index=0&id=2241a4aa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2241a4aa"]])

export default __exports__